import axios from "axios";
import { store } from "../app/store";

// Extend the axios request config type to include custom headers
declare module "axios" {
  interface AxiosRequestConfig {
    customHeaders?: Record<string, string>;
  }
}

axios.interceptors.request.use(
  (config) => {
    const { signMsg, signature } = store.getState().auth;

    if (
      signMsg &&
      signature &&
      typeof signMsg === "string" &&
      typeof signature === "string"
    ) {
      config.headers.signmsg = signMsg;
      config.headers.signature = signature;
    }

    // Add custom headers if provided in the request config
    if (config.customHeaders) {
      Object.assign(config.headers, config.customHeaders);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
